// extracted by mini-css-extract-plugin
module.exports = {"main":"layout-module--main--2yme8","wrapper":"layout-module--wrapper--1TYsl","headerContent":"layout-module--header-content--3eMSZ"};